import { Timer } from '../game/Timer.js';
import { LEVEL_IDS, LAST_LEVEL_ID } from '../config.js';

const LEVEL_NAMES = { 1: '入门', 2: '进阶', 3: '大师' };

export class WinOverlay {
  /**
   * @param {HTMLElement} root
   * @param {import('../storage/ProgressStore.js').ProgressStore} store
   * @param {object} callbacks
   * @param {(nextLevelId: number) => void} callbacks.onNext
   * @param {() => void} callbacks.onReplay
   * @param {() => void} callbacks.onLevelSelect
   * @param {() => void} callbacks.onMainMenu
   */
  constructor(root, store, { onNext, onReplay, onLevelSelect, onMainMenu }) {
    this.root = root;
    this.store = store;
    this.onNext = onNext;
    this.onReplay = onReplay;
    this.onLevelSelect = onLevelSelect;
    this.onMainMenu = onMainMenu;
    this.el = null;
  }

  show(levelId, timeMs) {
    this.hide();
    const isLast = levelId >= LAST_LEVEL_ID;
    const panel = document.createElement('div');
    panel.className = 'panel win-overlay';
    if (isLast) {
      panel.innerHTML = this._renderFullClear();
      panel.querySelector('[data-action="menu"]').addEventListener('click', () => this.onMainMenu());
    } else {
      panel.innerHTML = this._renderSingleClear(levelId, timeMs);
      panel.querySelector('[data-action="next"]').addEventListener('click', () => this.onNext(levelId + 1));
      panel.querySelector('[data-action="replay"]').addEventListener('click', () => this.onReplay());
      panel.querySelector('[data-action="select"]').addEventListener('click', () => this.onLevelSelect());
    }
    this.root.appendChild(panel);
    this.el = panel;
  }

  _renderSingleClear(levelId, timeMs) {
    const best = this.store.getBestTime(levelId);
    return `
      <h2>✨ 过关！</h2>
      <div class="win-stats">
        <div class="row"><span class="label">本次用时</span><span class="value">${Timer.format(timeMs)}</span></div>
        <div class="row"><span class="label">最佳</span><span class="value">${Timer.format(best)}</span></div>
      </div>
      <div class="btn-row">
        <button class="btn" data-action="next">下一关</button>
        <button class="btn secondary" data-action="replay">重玩</button>
        <button class="btn secondary" data-action="select">返回关卡选择</button>
      </div>
    `;
  }

  _renderFullClear() {
    const rows = LEVEL_IDS.map((id) => {
      const best = this.store.getBestTime(id);
      return `<div class="row"><span class="label">${LEVEL_NAMES[id] || id}</span><span class="value">${Timer.format(best)}</span></div>`;
    }).join('');
    let total = 0;
    let allCleared = true;
    for (const id of LEVEL_IDS) {
      const t = this.store.getBestTime(id);
      if (t === null) { allCleared = false; break; }
      total += t;
    }
    const totalStr = allCleared ? Timer.format(total) : Timer.format(null);
    return `
      <h2>🏆 全部通关！</h2>
      <div class="win-stats">
        ${rows}
        <div class="row total"><span class="label">总计</span><span class="value">${totalStr}</span></div>
      </div>
      <div class="btn-row">
        <button class="btn" data-action="menu">返回主菜单</button>
      </div>
    `;
  }

  hide() {
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.el = null;
  }
}
